import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import $ from 'jquery';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import BrowserUtil from '../../util/BrowserUtil';
import loginIcon from '../../images/icons/loginicon.png';
import CoreAjax from '../../util/CoreAjax';

var loginServerResponses = {
	200: 'Success.',
	 600: 'User ID expired.',
	 700: 'Invalid User ID or Password.',
	 500: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:<email>"><email></a>.',
	 0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>.'
};

class UnifiedLogin extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
			plp_userinput: this.props.userid || "",
			password: '',     
			submitButtonDisabled: false,
			serverMessage: this.props.errMsg || "",
			source:"",
			loginType:this.props.loginType || "userid",
			userLoginAllowed:false
		};

		this.handleChange = this.handleChange.bind(this);
		this.userIdChange = this.userIdChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showforgotPwd = this.showforgotPwd.bind(this);
		this.showCreateAccount = this.showCreateAccount.bind(this);
		this.googleLogin = this.googleLogin.bind(this);
		this.toggle_GSignin=this.toggle_GSignin.bind(this);
		this.myTrackerInstance = this.getTracker();
		
		this.navigationKey="PLP_Navigation";

		this.navigateUrl = props.navigateURL || window.location.href;
		
		
		this.gaFrom = this.props.gaFrom;
		this.gasignin = " - Returning User";
		//console.log("this.gaFrom:::::::::::",this.gaFrom);
		if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
			this.gaFrom = this.gaFrom+" Home - Join";
		}else{
			this.gaFrom = "Sign In - Users who have independently registered";
			this.gasignin = "";
		}
		//console.log("this.gaFrom2222:::::::::::",this.gaFrom);
		//console.log("UnifiedLogin Loading"+(this.navigateUrl || 'None'));  
	}
	componentWillReceiveProps(nextProps) {
		var me = this;
        //console.log('componentWillReceiveProps', nextProps);    
        this.setState({	
        	plp_userinput: nextProps.userid || "",
        	password: '',     
        	submitButtonDisabled: false,
        	serverMessage: "",
        	source:"",
        	loginType:nextProps.loginType || "userid"
        });
        
        this.gaFrom = nextProps.gaFrom;
       // console.log("this.gaFrom:::::::::::",this.gaFrom);
        if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
        	this.gaFrom = this.gaFrom+" Home - Join";
        }else{
        	this.gaFrom = "Users who have independently registered - Sign Up";
        }

				//console.log("this.gaFrom:::::::::::",this.gaFrom);
			 // console.log("UnifiedLogin Testing"+(this.navigateUrl || 'None'));  
    }
    componentDidMount(){
			//$(".socialLoginContainer").hide();
			this.sessionCheck();	
    } 


    handleChange(e) {
    	const target = e.currentTarget;	
    	this.form.validateFields(target);

    	this.setState({
    		[target.name]: target.value,
    		submitButtonDisabled: !this.form.isValid()
    	});
    }

    userIdChange(e){
    	const target = e.currentTarget;

    	// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
    	// if(phoneRegx.test(target.value)){
    	// 	this.setState({loginType:"mobile", serverMessage: ""});
    	// }else{
    	// 	this.setState({loginType:"email", serverMessage: ""});
        // }
        this.setState({loginType:"email", serverMessage: ""});
    	this.handleChange(e);
    }

    handlePasswordChange(e) {    
    	this.handleChange(e);
    }

    hmNav = function(userobj){
			//console.log("UnifiedLogin hmnav "+this.navigateUrl)
		/*if(this.props.liveFeed == "true" || this.props.liveFeed == true){
			window.top.location.href = "/";
			return;
		}*/		
		//console.log("this.navigateUrl::::"+this.navigateUrl);
		if(this.navigateUrl === null){
			// Do nothing
		}else if(this.navigateUrl == "/product-details"){
			window.top.location.href = this.navigateUrl;
		}else{			
			if(this.productsAvailableToAccess(userobj)){				
				window.top.location.href = "/landing";
			}else{
				if(userobj && userobj.userRole && userobj.userRole.role && userobj.userRole.role.toUpperCase() === "TCHR"){
					window.top.location.href = "/sg/products";
				}else{
					window.top.location.href = this.navigateUrl;	
				}				
			}
		}
		
	}

	productsAvailableToAccess(userobj){
		var user = userobj;
		//console.log("user::::",user);
		if(user != null){
			var permissions = user.entlHistory;//console.log("permissions:::",permissions);
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							return true;
						}
					}
				}
			}
		}

		return false;
	}
	
	storeRedirectUrl(){
		let redirectUrl = null;
		/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}

		if(redirectUrl){
			BrowserStorageUtil.storeItem("loginSrc", redirectUrl);
		}*/
	}

	//testplpum.heymath.com/additionalInfo/update
	updateUserType(commonCallback){
		var me=this;
		var callBackSuccess = function(response){
			if(response!== null){
				//console.warn("user type",response)
				me.getUser().store(response);
			}

			if(typeof commonCallback === "function"){
				commonCallback.apply(this,[response]);
			}
		}

		var callBackFailure = function(response){
			//console.warn("failure ",response);

			if(typeof commonCallback === "function"){
				commonCallback.apply(this);
			}
		}

		super.updateUserType(callBackSuccess,callBackFailure)
	}

	unifiedSubmitForm = function(){
		var formData = {
			"userId":this.state.plp_userinput,
			"password":this.state.password
		}
		
		
		var me =this;
		me.setState({submitButtonDisabled: true});

		
		var callBackSuccess = function(response){
			
			if(response !== null){
				if(response.source=="plp"){
					if(response.authenticated){
						//Setting user object at the browser level
						
						me.getUser().store(response.user);
						me.storeRedirectUrl();
						
						try{
							me.doLumosLogout();
						}catch(e){}
						me.setState({submitButtonDisabled: false,source:response.source});
						try{						
							var userObj = response.user;
							var loginObj = {
								"user_id" : (userObj == null) ? "" : userObj.userId,
								"login_id" : me.state.plp_userinput,
								"user_agent" : navigator.userAgent,
								"platform" : navigator.platform,
								"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
								"ip_address" : "ip_address",
								"result" : true,
								"session_id" : (userObj == null) ? "" : userObj.authToken
							}
							
							me.storeTrackEvent("login", loginObj);
						}catch(e){}
						
	
						if(!me.tracked){
							me.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-in"});
							me.tracked = true;
						}
						
						let afterUpdate = function(response){
							if(typeof me.props.callBack === "function"){
								me.props.callBack(response);
								return;
							}

							me.hmNav(response);
						};
						me.updateUserType(afterUpdate);
					}else{
						if(response.message == "provider_forbidden"){						
							me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login")});
						}else{					
							me.setState({ submitButtonDisabled: false, serverMessage: me.rb(response.message)});
						}
						//me.showAlert(me.rb("alert"),me.rb(response.message));
						me.trackMe(false);
					}
				}
				else if(response.source=="lumos"){
					try{
						me.doPLPLogout();
					}catch(e){}

					switch (response.code) {
						case 200:
						case 402:
							me.setState({source:response.source});
							window.top.location.href = response.link;
						break;
						case 500:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.codeus].replace(/<email>/g, response.link);
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code].replace(/<email>/g, response.link)});
						break;
						case 600:
						case 700:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.code];
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code] });
						break;
						default:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[0];
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[0]});
					}
				}
			}	
		}

		var PLPcallBackFailure = function(response){
			//console.log("response : ", response);
			me.trackMe(false);
			me.setState({submitButtonDisabled: false});
		}

		var callBackFailure = function(response){
			//console.log("response : ", response);
			//me.trackMe(false);
			//me.setState({submitButtonDisabled: false});
			new NativeAjax(me.getUrlFor("PLP_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
		}

		//new HmAjax(this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);
		new NativeAjax(this.getUrlFor("LUMOS_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess, callBackFailure);
		me.getUser().clearOldUser();
		
	}
	
	getUserStatus(){

		if(this.state.plp_userinput.length<=0){
			return;
		}
		
		var formData = {
			"verificationId":this.state.plp_userinput
		}

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				//console.log("response : ", response,"me.props.from:::",me.props.from);					
				if(response.user_exists){			
					me.setState({userLoginAllowed:true});
				}else{
					if(response.message == "provider_forbidden"){						
						me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login")});
					}else{					
						//me.setState({userLoginAllowed:false});
						//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
						me.checkValidUserInput();
					}					
				}
			}

			
		}

		var callBackFailure = function(response){
			//console.log("response : ", response);	
			me.setState({submitButtonDisabled: false});
		}

		new HmAjax(this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);
		
	}
	checkValidUserInput(){
		var me = this;
        var userinput = this.state.plp_userinput;
        
        if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
            me.setState({userLoginAllowed:false});
            me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
        }else{
            me.setState({submitButtonDisabled: false, serverMessage: me.rb("za_login.invalidinput.msg")});
        }
		// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		// if(phoneRegx.test(userinput)){			
		// 	if(userinput.length == 10){				
		// 		me.setState({userLoginAllowed:false});
		// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
		// 	}else{
		// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
		// 	}
		// }else{
		// 	if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
		// 		me.setState({userLoginAllowed:false});
		// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
		// 	}else{
		// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
		// 	}
		// }
	}
	doLumosLogout(){
		super.doLumosLogout();		
	}

	doPLPLogout(){
		var me = this;
		var callBackSuccess = function(resp){
		 	me.UserStore.clearOldUser();
			//me.initiateTrack("logout",{});

			// setTimeout(function(){
			// 	me.UserStore.clearOldUser();
			// 	window.location.href = me.getUrlFor("PRELOGIN_PAGE");
			// },500);
		}

		var callBackFailure = function(resp){
			console.error("Logout failed.");
		}

		super.doPLPLogout(callBackSuccess,callBackFailure);
	}

	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			this.unifiedSubmitForm();  
			// if(this.state.userLoginAllowed){
			// 	this.submitForm();  
			// }else{
			// 	this.getUserStatus();
			// }
		}
	}
	
	trackMe(result,userObj=null){		
		var trackObj = {
			"user_id" : (userObj == null) ? "" : userObj.userId,
			"login_id" : this.state.plp_userinput,
			"user_agent" : navigator.userAgent,
			"platform" : navigator.platform,
			"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
			"ip_address" : "ip_address",
			"result" : (result === true),
			"session_id" : (userObj == null) ? "" : userObj.authToken
		}

		this.initiateTrack("login",trackObj);
	}
	showCreateAccount(){
		if(!this.tracked){
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-signup"});
			this.tracked = true;
		}

		this.props.callbackCreateAccount(this.navigateUrl,this.props.freetrail);
	}
	showforgotPwd(){
		this.props.callbackForgotPwd(this.state.source);
    }
     
	googleLogin(){
		if(!this.tracked){
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});
			this.tracked = true;
		}

		var navigateObj = {
			navigateURL:this.navigateUrl
		}
		BrowserStorageUtil.storeSessionItem(this.navigationKey, JSON.stringify(navigateObj));
		
		window.top.location.href = this.getUrlFor("GOOGLE_LOGIN_API");
	}

	toggle_GSignin(e){
		var me=this;
		$(".socialLoginContainer").slideToggle("fast","swing",function(){
			if($(".showmore-signin").text()==me.rb("unified_login.show_more")){
				$(".showmore-signin").css("color","#8b9095");
				$(".showmore-signin").text(me.rb("unified_login.Hide"));
			}else{
				$(".showmore-signin").css("color","#01babd");
				$(".showmore-signin").text(me.rb("unified_login.show_more"));
			}
		});
	}

	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { return (
			<div className="row nomargin loginParent">
			<div className="col-sm-4 nopadding loginLeftSection">
			<h1 className="loginLeftContent">{this.rb("unified_login.login")}</h1>
			<div className="charactercontainer d-none d-sm-block">
			<img className="charactericons loginIcon" src={loginIcon} />
			</div>
			</div>


			<div id="loginRoot" className="plpLogin col-sm-8">

			<div className="container">

			<div className="row">
			<div className="col-md-12">

			<div className="row">
			<div className="col-md-12 mx-auto nopadding">
			<div className="rounded-0">

			<div className="text-center ">

			<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
			onSubmit={this.handleSubmit} noValidate>

			<FormGroup for="plp_userinput">
			{/* {( () => {
				if(this.state.loginType == "mobile"){
					return (
						<span className="countrycode">+91</span>
						);
				}
			})()} */}

			<FormControlInput type="plp_userinput" className={"plp_userinput "+this.state.loginType} name="plp_userinput" placeholder={this.rb("unifiedlogin.userplaceholder")}
			value={this.state.plp_userinput} onChange={this.userIdChange}
			required minLength={1} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>

			<FieldFeedbacks for="plp_userinput">
			<FieldFeedback when="valueMissing">{this.rb("za_unifiedlogin.useridrequired")}</FieldFeedback>
			<FieldFeedback when="*" />
			</FieldFeedbacks>
			</FormGroup>


			{( () => {
				// if(this.state.userLoginAllowed){
					return (
						<div>
						<FormGroup for="password">		
						<FormControlInput type="password" className="password" name="password" placeholder={this.rb("login.password")}
						innerRef={password => this.password = password}
						value={this.state.password} onChange={this.handlePasswordChange}
						required minLength={1} maxLength={50} tabIndex="4"/>
						<FieldFeedbacks for="password" show="all">
						<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
						</FieldFeedbacks>
						</FormGroup>
						<div data-ga={"Home - "+this.gaFrom + this.gasignin +" - Forgot Password"} className="text-right ufd-forgotPassword josefinsansFont" onClick={this.showforgotPwd}>
						{this.rb("forgot_password")}
						</div>
						</div>
						);
					// }
				})()}



				<div className="server-messages">{this.state.serverMessage}</div>

				<button data-ga={"Home - "+this.gaFrom + this.gasignin +"  - Sign In"} disabled={this.state.submitButtonDisabled} className="submitButton">{this.rb("unified_login.login")}</button>
				</FormWithConstraints>	
				</div>
				</div>
				</div>


				</div>

				</div>
				</div>
				</div>

				<div className="container">
<div className="row">
				<div className="col-md-12 pt-10">                         
			{/*<hr className="hr-text" data-content="OR" />*/}
			{/* <div className="text-center josefin">OR</div> onClick={this.toggle_GSignin}*/}

			<div className="text-center josefin showmore-signin" >{this.rb("za_unified_login.or")}</div>
			<div className="socialLoginContainer text-center">                                       
			<div data-ga={"Home - "+this.gaFrom + this.gasignin +" - Continue with Google"} className="socialLoginButtons google" onClick={this.googleLogin}>
			<i className="fab fa-google"></i>
			{this.rb("login.continuegoogle")}
			</div>
			{/* <span className="google-tooltip text-center josefin ">{this.rb("unified_login.google_hint")}</span> */}
			</div>
			</div>
			</div>
			</div>

			<div className="text-center">
			<span className="">
			{this.rb("register.donthaveaccount")}
			</span>
			<span data-ga={"Home - "+this.gaFrom + this.gasignin + " - Sign Up"} className="text-center loginCreateNewAccount josefinsansFont pl-10 resendButton" onClick={this.showCreateAccount}>
			{this.rb("unified_login.createnewaccount")}
			</span>
			</div>

			</div>
			</div>
			);}
		}
	}

	export default UnifiedLogin;



// WEBPACK FOOTER //
// ./src/views/sg/sg_UnifiedLogin.js